
import { Component, Vue, Watch } from 'nuxt-property-decorator'

@Component
export default class AppEmbeddedAdviser extends Vue {
  isLoading = true
  hasError = false
  iframeKey = 0
  private loadTimeout: ReturnType<typeof setTimeout> | null = null
  private restoreScroll: (() => void) | null = null

  get iframeUrl (): string {
    return new URL(`/${this.$i18n.locale}/embedded/ai-adviser/`, this.$config.BASE_URL).href
  }

  mounted () {
    window.addEventListener('message', this.onMessage)
    window.addEventListener('keydown', this.onKeydown)
    this.startLoading()

    if (window.matchMedia('(max-width: 767px)').matches) {
      const { style } = document.body
      const scrollY = window.scrollY
      const previous = { position: style.position, top: style.top, left: style.left, right: style.right, overflow: style.overflow }
      Object.assign(style, { position: 'fixed', top: `-${scrollY}px`, left: '0', right: '0', overflow: 'hidden' })
      this.restoreScroll = () => {
        Object.assign(style, previous)
        window.scrollTo(0, scrollY)
      }
    }
  }

  @Watch('iframeUrl')
  startLoading () {
    this.clearLoadTimeout()
    this.isLoading = true
    this.hasError = false
    this.loadTimeout = setTimeout(this.onError, 20000)
  }

  onLoad () {
    this.clearLoadTimeout()
    this.isLoading = false
  }

  onError () {
    this.clearLoadTimeout()
    this.isLoading = false
    this.hasError = true
  }

  retry () {
    this.iframeKey++
    this.startLoading()
  }

  onMessage (event: MessageEvent) {
    const iframe = this.$refs.iframe as HTMLIFrameElement | undefined
    if (
      iframe &&
      event.source === iframe.contentWindow &&
      event.origin === new URL(this.iframeUrl).origin &&
      event.data?.type === 'ai-adviser:close'
    ) {
      this.$emit('close')
    }
  }

  onKeydown (event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.$emit('close')
    }
  }

  clearLoadTimeout () {
    if (this.loadTimeout !== null) {
      clearTimeout(this.loadTimeout)
      this.loadTimeout = null
    }
  }

  beforeDestroy () {
    window.removeEventListener('message', this.onMessage)
    window.removeEventListener('keydown', this.onKeydown)
    this.clearLoadTimeout()
    this.restoreScroll?.()
  }
}
